import * as Styled from '../styled';
import { Dinosaur, Button } from '~components';
import { useNavigate } from 'react-router-dom';

function NetworkError() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-2);
  };

  return (
    <Styled.Wrapper role="region">
      <Dinosaur />
      <Styled.Title>Sem conexão</Styled.Title>
      <Styled.Description variant="sub300">
        Verifique os cabos de rede, modem e roteador. Se estiver conectado a uma
        rede Wi-Fi, tente se reconectar.
      </Styled.Description>
      <Button variant="primary" onClick={handleClick}>
        Recarregar página
      </Button>
    </Styled.Wrapper>
  );
}

export default NetworkError;
